import Camera from "react-html5-camera-photo";
import styled from "styled-components";

export const RightContainer=styled.div`
    flex:50;
    height:100%;
    display: flex;
    flex-direction: column;
`;

export const RightContainer2 = styled(RightContainer)`
    @media screen and (max-width: 600px){
        flex-direction: column;
        }
`

export const LeftContainer=styled.div`
    height:100%;
    display: flex;
    flex-direction: column;
    flex:50;
`;

export const ProfilePicDiv = styled.div`
    // @media screen and (max-width: 600px){
    //     margin-left: auto;
    //     }  
`;

export const ProfileImageWrapper = styled.div`
    position: relative;
    width: 100px;
    height: 120.765px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 2px solid #FFF;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
    margin-top: 0px;
    overflow: hidden;
`;

export const ProfileImageBackground = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.src});
    background-size: cover;
    background-position: center;
    filter: blur(8px);
    transform: scale(1.1);
`;

export const ProfilePic=styled.img`
    position: relative;
    width: 100px, 
    height: 100px, 
    aspectRatio: 480/640;
    object-fit: contain;
`
export const RemoveProfileImage=styled.div`
    display:flex;
    justify-content: center;
    margin-bottom: 1rem;
`
export const RemoveProfilePic=styled.img`
    max-width:70px;
    max-height:80px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 2px solid #FFF;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
`
export const ProfileEditIcons=styled.div`
    display:flex;
    align-items:center;
    // margin-left:1.5em;
    width: 78%;
    justify-content: flex-end;
    position: absolute;
    right: 10%;
    top:-28%;
`

export const ProfileEditLine=styled.div`
    border-left: 1px solid #ccc;
    height:20px;
    margin: 0 14px;
`

export const EditIcon=styled.img`
    width: 16px;
    height: 16px;
    margin-left: 2px;
    cursor: pointer;
    position: relative;
    &.notClickable{
       pointer-events: none;
    }
    &.Clickable{
    pointer-events: unset;
    }
`

export const DeleteIcon=styled.img`
    width: 16px;
    height: 16px;
    margin-left: 2px;
    cursor: pointer;
    position: relative;
`
export const EditProfileWrapper=styled.div`
    padding: 22px 0 15px 38px;
    @media screen and (max-width: 600px){
        padding: 22px 15px 15px 22px;
    }
    
`
export const CookieSettingsWrapper=styled(EditProfileWrapper)`
    text-align: left;
`

export const CookieWrapper=styled.div`
    width:100%;
    padding-bottom: 14px;
    ${props => props.necessary && `
        border-bottom: 1.5px solid black;
    `}
    display:flex;
    align-items: center;
`
export const EditPhoneWrapper=styled.div`
    padding: 25px 0 37px 46px;
    width:100%
`
export const EditAddressWrapper=styled.div`
    padding: 29px 0 36px 24px;
`

export const EditProfileImage=styled.img`
    width: 100px;
    height: 88.81px;
`
export const DeleteVectorImage=styled.img`
    width: 80px;
    height: 80px;
    @media screen and (max-width: 750px){
        margin: 0 auto;
    }
`
export const Bullet=styled.img`
    width: 8px;
    height: 8px;
    margin-right: 12.5px;
    margin-top: 5px;
`

export const PrimaryButton = styled.button`
border-radius: 8px;
border: 1px solid #FF6B00;
background: #F66700;
box-shadow: 0px 3px 0px 0px #C75300;
padding: 9px 18px 12px 14px;
height: fit-content;
gap: 8px;
flex: 1 0 0;
align-self: stretch;
cursor: pointer;
${props => props.successbutton && `
display: block;
margin-left: auto;
margin-right: auto;
margin-top: 45px;
 `
}
${props => props.giveConnect && `
display: flex;
flex: unset;
 `
}

${props => props.confirmpopupbutton && `
margin-right: 5px;
flex: none;
 `
}
& span{
    position:relative;
    color: #FFF;
    font-family: Lato-Bold;
    font-size: 18px;
    font-style: normal;
    line-height: 120%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}
}`;

export const ImagePicker = styled.label`
border-radius: 8px;
border: 1px solid #FF6B00;
background: #F66700;
box-shadow: 0px 3px 0px 0px #C75300;
padding: 9px 18px 12px 14px;
height: fit-content;
gap: 8px;
flex: 1 0 0;
align-self: stretch;
cursor: pointer;
& span{
    position:relative;
    color: #FFF;
    font-family: Lato-Bold;
    font-size: 18px;
    font-style: normal;
    line-height: 120%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}

& input[type="file"]{
    display: none;
}
}`;

export const SaveCookies = styled(ImagePicker)`
    position:relative;
    left:50%;
    transform: translatex(-50%);
    @media screen and (max-width: 600px){
        margin-bottom: 5%;
    }

}`;

export const TakePhoto= styled.a`
    display: flex;
    justify-content: center;
    color: rgb(199, 83, 0);
    cursor: pointer;
     &: hover{
        color: #C75300;
     }
    }`; 

export const PlainButton=styled.button`
border-radius: 8px;
border: 1px solid #F66700;
background: #FFF;
margin-left: ${({marginLeft}) => (marginLeft ? marginLeft : "0")};
padding: 11px 18px;
height: fit-content;
cursor: pointer;
& span{
    color: #000;
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
}
}`;

export const CustomCamera=styled(Camera)`
    height: 100vh;
    width: 100vw;
`
export const SubmitButton = styled.div`
padding: 0.5rem;
background-color: rgb(255, 107, 0);
box-shadow: rgb(199, 83, 0) 0px 3px 0px;
color: rgb(255, 255, 255);
border-radius: 8px;
text-align: center;
font-size: 18px;
font-family: Lato;
cursor: pointer;
width:25%;
margin:0px auto 3%;
@media screen and (max-width: 750px){
    width:50%;
    margin-top:2%;
}
`
export const CancelClick= styled.a`
    display: flex;
    justify-content: center;
    color: rgba(17, 17, 17, 1);
    cursor: pointer;
    font-weight: 600;
    font-family: 'Lato';
    font-size: 15px;
    @media screen and (max-width: 750px){
        margin-top:5%;
    }
`; 
